module.exports = __webpack_public_path__ + "assets/43143789225534273d1d4e6e1630f739.png";